export const brandedGameIds = { 747: 138, betfair: 120, turkish: 158 };
export const brandedGameNameDependOnIds = {
  [brandedGameIds['747']]: 747,
  [brandedGameIds.betfair]: 'betfair',
  [brandedGameIds.turkish]: 'turkish',
};
